import { HTTP_DELETE, HTTP_GET, HTTP_POST, HTTP_PUT } from "../../utils/constants";
import { fetchJson } from "./http";

export const apiFetch = (api, options, method) => async (dispatch, getState) => {
	const auth = getState().auth;

	if (options) {
		options.method = method;
	}

	let headers = (options.headers = options.headers || {});

	if (options.body && typeof options.body !== "string") {
		options.body = JSON.stringify(options.body);
	}

	if (auth.signedIn) {
		headers.Authorization = `Bearer ${auth.accessToken}`;
	}

	return await fetchJson(api, options);
};

export const apiGet =
	(api, options = {}) =>
	async (dispatch) => {
		return await dispatch(apiFetch(api, options, HTTP_GET));
	};

export const apiPut =
	(api, options = {}) =>
	async (dispatch) => {
		return await dispatch(apiFetch(api, options, HTTP_PUT));
	};

export const apiPost =
	(api, options = {}) =>
	async (dispatch) => {
		return await dispatch(apiFetch(api, options, HTTP_POST));
	};

export const apiDelete =
	(api, options = {}) =>
	async (dispatch) => {
		return await dispatch(apiFetch(api, options, HTTP_DELETE));
	};

const createRequest = (method) => {
	return (url, payload) => async (dispatch) => {
		const { status, data } = await dispatch(method(url, { body: payload }));

		return new Promise((resolve, reject) => {
			if (status >= 200 && status <= 299) {
				return resolve({ data, status });
			}

			return reject({ status: status.status, response: JSON.parse(status.message) });
		});
	};
};

export default {
	Get: createRequest(apiGet),
	Post: createRequest(apiPost),
	Put: createRequest(apiPut),
	Delete: createRequest(apiDelete),
};
